import React from 'react'

import { TableContainer, TableContainerOdd } from './Table.styles'
const Table = ({ borderCollapse, borderSpacing, border, margin, cellpadding, children, background, hoverOff = false, oddHighlight = false, ...props }) => {
    if (oddHighlight) {
        return (
            <TableContainerOdd {...props} hoverOff={hoverOff} margin={margin} cellpadding={cellpadding} background={background} border={border} borderSpacing={borderSpacing} borderCollapse={borderCollapse}><tbody>{children}</tbody></TableContainerOdd>
        )
    }
    return (
        <TableContainer {...props} hoverOff={hoverOff} margin={margin} cellpadding={cellpadding} background={background} border={border} borderSpacing={borderSpacing} borderCollapse={borderCollapse}><tbody>{children}</tbody></TableContainer>
    )
}

export default Table